import { ColDef } from 'ag-grid-community';
import { advancedTextColumnFilterOptions } from 'src/components/molecules/AdvancedTextColumnFilter/AdvancedTextColumnFilter';
import { ChainFurnitureZoneRow } from 'src/hooks/chain-furniture-zone/table/useChainFurnitureZoneRows';

export const defaultColDef: ColDef = {
    flex: 1,
    sortable: true,
    suppressMovable: true,
    suppressHeaderMenuButton: true,
};

export const defaultColumns: ColDef<ChainFurnitureZoneRow>[] = [
    {
        field: 'name',
        headerName: 'Name',
        ...advancedTextColumnFilterOptions,
    },
    {
        field: 'description',
        headerName: 'Description',
        ...advancedTextColumnFilterOptions,
    },
];
